export default "/static/media/fashion.63e3329e.css";